import React, { Fragment } from "react";
import { useSignOut } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import auth from "../../../../FirebaseInit/FirebaseInit";
import Loading from "../../../Shear/Loading/Loading";

const StudentItem = ({ data, index, setUpdate }) => {
  const [signOut, Sloading] = useSignOut(auth);
  const navigate = useNavigate();
  const makeAdminHandler = () => {
    fetch(`https://itghar-back.onrender.com//order/:trxID`, {
      method: "PUT",

      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((response) => {
        if (response?.status === 401 || response?.status === 403) {
          localStorage.removeItem("accessToken");
          signOut();
          navigate("/");
        }

        return response.json();
      })
      .then((json) => {
        if (json?.status) {
          toast.success("SuccessFully Admin");
          setUpdate(true);
        } else {
          toast.error(json?.error);
        }
      });
  };

  if (Sloading) {
    return <Loading />;
  }
  return (
    <Fragment>
      <tbody>
        <tr>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <p className="text-gray-600 whitespace-no-wrap">{index + 1}</p>
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            {data.courseType}
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            {data.contactNo}
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <span className="relative inline-block px-3 py-1 font-semibold  cursor-pointer leading-tight">
              <span className="relative">{data.email}</span>
            </span>
          </td>
          <td className="px-5 py-5 border-b border-[#e5e7eb] bg-white text-sm">
            <button
              onClick={makeAdminHandler}
              className="bg-[green] py-2 px-2 rounded-lg text-[#fff] text-sm font-semibold"
            >
              Paid
            </button>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

export default StudentItem;
